import React, { useState } from 'react';
// Import your images here

import intershipduration from "../../../assets/images/intershipduration.svg";
import intershiptype from "../../../assets/images/intershiptype.svg";
import booktimeslot from "../../../assets/images/booktimeslot.svg";
import bookseat from "../../../assets/images/book-seat.svg";
import finishyourprogress from "../../../assets/images/finish-your-progress.svg";
import personalinfo from "../../../assets/images/personal-info-icon.png";



const InternshipWeb = () => {
  const [activeTab, setActiveTab] = useState('basics'); // Default tab

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <section id="devops">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <h2 className="text-purple">6-Month Web Development Roadmap </h2>
            <p className="fw-medium">(From Scratch to Expert)</p>
          </div>
        </div>
        <div className="row my-5 devcontaint">
          <div className="col-md-3 col-12">
            <div className="left-side h-100 flex-md-row flex-column">
              <ul className="d-md-block d-flex">
                {/* Tab Buttons */}
                <li role='button'
                  className={`d-flex flex-md-row flex-column ${activeTab === 'basics' ? 'active' : ''}`}
                  onClick={() => handleTabClick('basics')}
                >
                  <div className={`fs-1 image-section type2    ${activeTab === 'basics' ? '' : '  '}`}>
                    1
                  </div>
                  <div className={`text-section d-md-inline ${activeTab === 'basics' ? 'text-danger d-inline' : 'd-none'}`}>
                    <h6 className="fw-bold" >Basics</h6>
                  </div>
                </li>

                <li
                  role='button' className={`d-flex flex-md-row flex-column ${activeTab === 'react' ? 'active ' : ''}`}
                  onClick={() => handleTabClick('react')}
                >
                  <div className="image-section type2 fs-2">
                    2
                  </div>
                  <div className={`text-section  d-md-inline ${activeTab === 'react' ? 'text-danger d-inline' : 'd-none'}`}>
                    <h6 className="fw-bold">React</h6>
                  </div>
                </li>

                <li role='button'
                  className={`d-flex flex-md-row flex-column ${activeTab === 'node-js' ? 'active' : ''}`}
                  onClick={() => handleTabClick('node-js')}
                >
                  <div className="image-section type2 fs-1">
                    3
                  </div>
                  <div className={`text-section  d-md-inline ${activeTab === 'node-js' ? 'text-danger d-inline' : 'd-none'}`}>
                    <h6 className="fw-bold">Node & Express js</h6>
                  </div>
                </li>

                <li role='button'
                  className={`d-flex flex-md-row flex-column ${activeTab === 'MongoDB' ? 'active' : ''}`}
                  onClick={() => handleTabClick('MongoDB')}
                >
                  <div className="image-section type2 fs-1">
                    4
                  </div>
                  <div className={`text-section  d-md-inline ${activeTab === 'MongoDB' ? 'text-danger d-inline' : 'd-none'}`}>
                    <h6 className="fw-bold">MongoDB</h6>
                  </div>
                </li>

                <li role='button'
                  className={`d-flex flex-md-row flex-column ${activeTab === 'full-stack' ? 'active' : ''}`}
                  onClick={() => handleTabClick('full-stack')}
                >
                  <div className="image-section type2 fs-1 ">
                    5
                  </div>
                  <div className={`text-section  d-md-inline ${activeTab === 'full-stack' ? 'text-danger d-inline' : 'd-none'}`}>
                    <h6 className="fw-bold">Full Stack</h6>
                  </div>
                </li>

                <li role='button'
                  className={`d-flex flex-md-row flex-column ${activeTab === 'interview-preparation' ? 'active' : ''}`}
                  onClick={() => handleTabClick('interview-preparation')}
                >
                  <div className="image-section type2 fs-1" >
                    6
                  </div>
                  <div className={`text-section  d-md-inline ${activeTab === 'interview-preparation' ? 'text-danger d-inline' : 'd-none'}`}>
                    <h6 className="fw-bold">Interview preparations</h6>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-9 col-12">
            <div className="right-side">
              {activeTab === 'basics' && (
                <div className="container mt-4">
                  <h1 className="fw-bold fs-3 text-danger mb-3">Introduction to Web Development & JavaScript Basics</h1>

                  <strong className="fw-bold fs-5 text-danger mb-2">Week 1: HTML & CSS Basics</strong>
                  <ul className="ms-4">
                    <li>
                      <strong>Day 1-2: Introduction to HTML:</strong> Structure of a webpage, tags, headings, paragraphs, links, images.
                    </li>
                    <li className="fs-6">
                      <strong>Day 3-4: Forms, tables, input elements, buttons:</strong>
                    </li>
                    <li className="fs-6">
                      <strong>Day 5-6: Introduction to CSS:</strong> Selectors, colors, fonts, padding, margin.
                    </li>
                    <li className="fs-6">
                      <strong>Day 7: Test Day:</strong> HTML & CSS Quiz/Practical test. Build a basic webpage.
                    </li>
                  </ul>

                  <strong className="fw-bold fs-5 text-danger mb-2">Week 2: Advanced CSS & JavaScript Basics</strong>
                  <ul className="ms-4">
                    <li>
                      <strong>Day 8-9: Flexbox Layout, CSS Grid:</strong>
                    </li>
                    <li className="fs-6">
                      <strong>Day 10-11: Introduction to JavaScript:</strong> Variables, data types, and operators.
                    </li>
                    <li className="fs-6">
                      <strong>Day 12-13: Loops (for, while, forEach), conditionals (if/else, switch):</strong>
                    </li>
                    <li className="fs-6">
                      <strong>Day 14: Test Day:</strong> CSS Flexbox/Grid quiz and small project (Responsive webpage).
                    </li>
                  </ul>

                  <strong className="fw-bold fs-5 text-danger mb-2">Week 3: DOM Manipulation & Advanced JavaScript</strong>
                  <ul className="ms-4">
                    <li>
                      <strong>Day 15-16: DOM Basics:</strong> Selecting elements, events, event listeners.
                    </li>
                    <li className="fs-6">
                      <strong>Day 17-18: Manipulating DOM elements:</strong> Adding/removing content, attributes, and styles.
                    </li>
                    <li className="fs-6">
                      <strong>Day 19-20: JavaScript Functions:</strong> Callbacks, closures, higher-order functions.
                    </li>
                    <li className="fs-6">
                      <strong>Day 21: Test Day:</strong> DOM Manipulation practical test.
                    </li>
                  </ul>

                  <strong className="fw-bold fs-5 text-danger mb-2">Week 4: JavaScript Advanced Concepts & Practice</strong>
                  <ul className="ms-4">
                    <li>
                      <strong>Day 22-23: Advanced JavaScript:</strong> Error handling (try/catch), destructuring, spread/rest operators.
                    </li>
                    <li className="fs-6">
                      <strong>Day 24-25: Practice advanced JavaScript concepts:</strong> Small projects.
                    </li>
                    <li className="fs-6">
                      <strong>Day 26-27: Review and revise JavaScript concepts:</strong>
                    </li>
                    <li className="fs-6">
                      <strong>Day 28: Test Day:</strong> JavaScript quiz covering all advanced concepts.
                    </li>
                  </ul>
                </div>



              )}
              {activeTab === 'react' && (
                <div className="container mt-4">
                  <h1 className="fw-bold fs-3 text-danger mb-3">React Basics and Advanced Concepts</h1>

                  <strong className="fw-bold fs-5 text-danger mb-2">Week 5: React Basics</strong>

                  <ul className="ms-4">
                    <li>
                      <strong>Day 29-30: Introduction to React:</strong>
                      Setting up React project, understanding components, JSX.
                    </li>

                    <li className="fs-6">
                      <strong>Day 31-32: Functional Components, Props:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 33-34: Class Components vs Functional Components, React Hooks (useState):</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 35: Test Day:</strong>
                      React Basics test and simple app (e.g., a counter app).
                    </li>
                  </ul>

                  <strong className="fw-bold fs-5 text-danger mb-2">Week 6: React State Management & Forms</strong>

                  <ul className="ms-4">
                    <li>
                      <strong>Day 36-37: Handling State in Functional Components with useState:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 38-39: React Router:</strong>
                      Routes, Link, and Navigation.
                    </li>

                    <li className="fs-6">
                      <strong>Day 40-41: Forms in React:</strong>
                      Controlled vs Uncontrolled components.
                    </li>

                    <li className="fs-6">
                      <strong>Day 42: Test Day:</strong>
                      React State & Forms quiz and form validation project.
                    </li>
                  </ul>

                  <strong className="fw-bold fs-5 text-danger mb-2">Week 7: React Advanced Concepts</strong>

                  <ul className="ms-4">
                    <li>
                      <strong>Day 43-44: Introduction to useEffect:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 45-46: Advanced React Patterns:</strong>
                      Component lifecycle, custom hooks.
                    </li>

                    <li className="fs-6">
                      <strong>Day 47-48: Context API for global state management:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 49-50: Redux Basics (Optional, advanced topic for later):</strong>
                      Actions, reducers, store.
                    </li>

                    <li className="fs-6">
                      <strong>Day 51: Test Day:</strong>
                      React Hooks and Context API quiz.
                    </li>
                  </ul>

                  <strong className="fw-bold fs-5 text-danger mb-2">Week 8: React Practice & Project</strong>

                  <ul className="ms-4">
                    <li>
                      <strong>Day 52-53: Build a simple React app:</strong>
                      (e.g., a To-Do list app).
                    </li>

                    <li className="fs-6">
                      <strong>Day 54-55: Work on a small React project:</strong>
                      Incorporating state management.
                    </li>

                    <li className="fs-6">
                      <strong>Day 56-57: Debugging React apps:</strong>
                      Using browser dev tools.
                    </li>

                    <li className="fs-6">
                      <strong>Day 58-59: Wrap-up with exercises and additional practice:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 60: Test Day:</strong>
                      Full React project assessment.
                    </li>
                  </ul>
                </div>


              )}
              {activeTab === 'node-js' && (
                <div className="container mt-4">
                  <h1 className="fw-bold fs-3 text-danger mb-3">Node.js, Express, and MongoDB</h1>

                  <strong className="fw-bold fs-5 text-danger mb-2">Week 9: Introduction to Node.js & NPM</strong>

                  <ul className="ms-4">
                    <li>
                      <strong>Day 61-62: Setting up Node.js:</strong>
                      Installing and understanding the Node environment.
                    </li>

                    <li className="fs-6">
                      <strong>Day 63-64: Introduction to NPM:</strong>
                      Installing packages, managing dependencies.
                    </li>

                    <li className="fs-6">
                      <strong>Day 65-66: Basic Node.js modules:</strong>
                      File system, HTTP, events.
                    </li>

                    <li className="fs-6">
                      <strong>Day 67: Introduction to RESTful APIs:</strong>
                      Basic concepts.
                    </li>

                    <li className="fs-6">
                      <strong>Day 68: Test Day:</strong>
                      Node.js basic concepts quiz.
                    </li>
                  </ul>

                  <strong className="fw-bold fs-5 text-danger mb-2">Week 10: Express.js Basics</strong>

                  <ul className="ms-4">
                    <li>
                      <strong>Day 69-70: Setting up Express server:</strong>
                      Routing with GET, POST methods.
                    </li>

                    <li className="fs-6">
                      <strong>Day 71-72: Middleware in Express:</strong>
                      Usage and custom middleware.
                    </li>

                    <li className="fs-6">
                      <strong>Day 73-74: Handling POST data:</strong>
                      Parsing JSON, handling query params.
                    </li>

                    <li className="fs-6">
                      <strong>Day 75: Test Day:</strong>
                      Express server and routing test.
                    </li>
                  </ul>

                  <strong className="fw-bold fs-5 text-danger mb-2">Week 11: Database Integration with MongoDB</strong>

                  <ul className="ms-4">
                    <li>
                      <strong>Day 76-77: Introduction to MongoDB:</strong>
                      NoSQL concepts, collections, documents.
                    </li>

                    <li className="fs-6">
                      <strong>Day 78-79: CRUD operations:</strong>
                      Creating, Reading, Updating, Deleting data.
                    </li>

                    <li className="fs-6">
                      <strong>Day 80-81: Installing and setting up MongoDB:</strong>
                      Locally or with MongoDB Atlas.
                    </li>

                    <li className="fs-6">
                      <strong>Day 82: Introduction to Mongoose:</strong>
                      Connecting Express to MongoDB with Mongoose.
                    </li>

                    <li className="fs-6">
                      <strong>Day 83: Test Day:</strong>
                      MongoDB CRUD operations and basic database integration.
                    </li>
                  </ul>

                  <strong className="fw-bold fs-5 text-danger mb-2">Week 12: Advanced Node.js & Express</strong>

                  <ul className="ms-4">
                    <li>
                      <strong>Day 84-85: Middleware in depth:</strong>
                      Authentication, logging.
                    </li>

                    <li className="fs-6">
                      <strong>Day 86-87: Error handling and validation in APIs:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 88-89: Building RESTful APIs:</strong>
                      With Express and MongoDB.
                    </li>

                    <li className="fs-6">
                      <strong>Day 90: Test Day:</strong>
                      Full backend REST API quiz.
                    </li>
                  </ul>
                </div>

              )}



              {activeTab === 'MongoDB' && (
                <div className="container mt-4">
                  <h1 className="fw-bold fs-3 text-danger mb-3">MongoDB & Database Integration</h1>

                  <strong className="fw-bold fs-5 text-danger mb-2">Week 13: MongoDB Deep Dive</strong>

                  <ul className="ms-4">
                    <li>
                      <strong>Day 91-92: Data Modeling in MongoDB:</strong>
                      Schema design and relationships.
                    </li>

                    <li className="fs-6">
                      <strong>Day 93-94: Aggregation in MongoDB:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 95-96: Indexing in MongoDB:</strong>
                      For performance optimization.
                    </li>

                    <li className="fs-6">
                      <strong>Day 97: MongoDB Transactions:</strong>
                      (if needed).
                    </li>

                    <li className="fs-6">
                      <strong>Day 98: Test Day:</strong>
                      MongoDB advanced concepts quiz.
                    </li>
                  </ul>

                  <strong className="fw-bold fs-5 text-danger mb-2">Week 14: Advanced CRUD & Mongoose</strong>

                  <ul className="ms-4">
                    <li>
                      <strong>Day 99-100: Advanced CRUD operations with Mongoose:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 101-102: Mongoose population for relational data:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 103-104: Data Validation:</strong>
                      Custom Validation in Mongoose.
                    </li>

                    <li className="fs-6">
                      <strong>Day 105: Working with images and file uploads in MongoDB:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 106: Test Day:</strong>
                      Mongoose and CRUD operations test.
                    </li>
                  </ul>

                  <strong className="fw-bold fs-5 text-danger mb-2">Week 15: Full-Stack Application Integration</strong>

                  <ul className="ms-4">
                    <li>
                      <strong>Day 107-108: Integrating frontend React with backend Express:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 109-110: Making API calls from React to Express with Axios:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 111-112: Connecting React to MongoDB through Express:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 113: Testing full-stack CRUD operations:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 114: Test Day:</strong>
                      Full-Stack integration quiz.
                    </li>
                  </ul>

                  <strong className="fw-bold fs-5 text-danger mb-2">Week 16: Advanced MongoDB Topics & Revision</strong>

                  <ul className="ms-4">
                    <li>
                      <strong>Day 115-116: Working with NoSQL relationships:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 117-118: Securing API with JWT (JSON Web Token):</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 119-120: Revising MongoDB and Express concepts:</strong>
                      With hands-on exercises.
                    </li>

                    <li className="fs-6">
                      <strong>Day 121: Test Day:</strong>
                      Final revision quiz for MongoDB and Express.
                    </li>
                  </ul>
                </div>

              )}

              {activeTab === 'full-stack' && (
                <div className="container mt-4">
                  <h1 className="fw-bold fs-3 text-danger mb-3">Full-Stack Integration & Authentication</h1>

                  <strong className="fw-bold fs-5 text-danger mb-2">Week 17: Full-Stack MERN Application</strong>

                  <ul className="ms-4">
                    <li>
                      <strong>Day 122-123: Setting up a complete MERN project:</strong>
                      (React + Express + MongoDB).
                    </li>

                    <li className="fs-6">
                      <strong>Day 124-125: Building API endpoints:</strong>
                      Integrating them into the React frontend.
                    </li>

                    <li className="fs-6">
                      <strong>Day 126-127: Handling asynchronous actions:</strong>
                      Making API calls.
                    </li>

                    <li className="fs-6">
                      <strong>Day 128: Implementing file uploads and storage:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 129: Test Day:</strong>
                      Full-stack MERN project assessment.
                    </li>
                  </ul>

                  <strong className="fw-bold fs-5 text-danger mb-2">Week 18: Authentication & Authorization</strong>

                  <ul className="ms-4">
                    <li>
                      <strong>Day 130-131: Setting up JWT authentication for MERN stack:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 132-133: Creating secure login/logout functionality:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 134-135: Implementing user roles:</strong>
                      Admin, User, and protecting routes.
                    </li>

                    <li className="fs-6">
                      <strong>Day 136: User registration and account verification:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 137: Test Day:</strong>
                      Authentication and Authorization practical test.
                    </li>
                  </ul>

                  <strong className="fw-bold fs-5 text-danger mb-2">Week 19: Advanced MERN Topics</strong>

                  <ul className="ms-4">
                    <li>
                      <strong>Day 138-139: Server-side rendering (SSR) with React:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 140-141: Using GraphQL with MongoDB:</strong>
                      For querying.
                    </li>

                    <li className="fs-6">
                      <strong>Day 142-143: WebSockets for real-time updates:</strong>
                      (Optional).
                    </li>

                    <li className="fs-6">
                      <strong>Day 144: Error handling and testing MERN applications:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 145: Test Day:</strong>
                      Advanced MERN concepts quiz.
                    </li>
                  </ul>

                  <strong className="fw-bold fs-5 text-danger mb-2">Week 20: MERN Practice & Testing</strong>

                  <ul className="ms-4">
                    <li>
                      <strong>Day 146-147: Testing MERN applications:</strong>
                      With Jest and Enzyme.
                    </li>

                    <li className="fs-6">
                      <strong>Day 148-149: Debugging common MERN issues:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 150: Wrapping up projects:</strong>
                      Additional practice.
                    </li>

                    <li className="fs-6">
                      <strong>Day 151: Test Day:</strong>
                      Full MERN application test and debugging.
                    </li>
                  </ul>
                </div>

              )}

              {activeTab === 'interview-preparation' && (
                <div className="container mt-4">
                  <h1 className="fw-bold fs-3 text-danger mb-3">Deployment, Advanced Topics & Interview Preparation</h1>

                  <strong className="fw-bold fs-5 text-danger mb-2">Week 21: Deployment & Cloud Integration</strong>

                  <ul className="ms-4">
                    <li>
                      <strong>Day 152-153: Deploying React apps on Netlify, Vercel:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 154-155: Deploying backend (Express) on Heroku:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 156-157: Using cloud services for database hosting (MongoDB Atlas):</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 158: Continuous Deployment using react pipelines:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 159: Test Day:</strong>
                      Deployment quiz (Netlify, Vercel, Heroku).
                    </li>
                  </ul>

                  <strong className="fw-bold fs-5 text-danger mb-2">Week 22: Interview Preparation & Advanced Topics</strong>

                  <ul className="ms-4">
                    <li>
                      <strong>Day 160-161: System design concepts and scaling applications:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 162-163: Building a complete full-stack application for interviews:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 164-165: Reviewing and practicing coding challenges:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 166-167: Preparing for MERN interviews:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 168: Test Day:</strong>
                      System design & interview prep quiz.
                    </li>
                  </ul>

                  <strong className="fw-bold fs-5 text-danger mb-2">Week 23: Mock Interviews & Aptitude Practice</strong>

                  <ul className="ms-4">
                    <li>
                      <strong>Day 169-170: Mock technical interviews:</strong>
                      System design, algorithms, problem-solving.
                    </li>

                    <li className="fs-6">
                      <strong>Day 171-172: Coding exercises and practice on platforms like LeetCode, HackerRank:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 173-174: Soft skills training, communication in interviews:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 175: Final mock interview with feedback:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 176: Test Day:</strong>
                      Final mock interview.
                    </li>
                  </ul>

                  <strong className="fw-bold fs-5 text-danger mb-2">Week 24: Final Review & Certification</strong>

                  <ul className="ms-4">
                    <li>
                      <strong>Day 177-178: Reviewing everything learned during the 6 months:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 179-180: Final review and job application strategies:</strong>
                    </li>

                    <li className="fs-6">
                      <strong>Day 181: Certification & final mock interview:</strong>
                    </li>
                  </ul>
                </div>

              )}
            </div>
          </div>
        </div>


      </div >
    </section >

  );
};

export default InternshipWeb;

      // <section className="internship" id="rounded-box-lg">
      //   <div className="container">
      //     <div className="bg-white">
      //       <div className="top-grid">
      //         <div className="left">
      //           <h2 className="text-purple">6-Month DevOps Roadmap</h2>
      //           <p className="fw-medium">From Scratch to Exper</p>
      //         </div>
      //         <div className="right">
      //           <p className="text-gray fw-medium">
      //           </p>
      //         </div>
      //       </div>

      //       <div className="intership-grid">
      //         <div className="left-side">
      //           <ul>
               
      //             <li role='button'
      //               className={`d-flex ${activeTab === 'basics ' ? 'active' : ''}`}
      //               onClick={() => handleTabClick('basics')}
      //             >
      //               <div className={`fs-1 image-section    ${activeTab === 'basics  months-type' ? ' ' : 'type2'}`}>
      //                 1
      //               </div>
      //               <div className={`text-section ${activeTab === 'basics' ? 'text-danger' : ''}`}>
      //                 <h6 className="fw-bold" >Basics</h6>
      //               </div>
      //             </li>

      //             <li
      //               role='button' className={`d-flex ${activeTab === 'react' ? 'active ' : ''}`}
      //               onClick={() => handleTabClick('react')}
      //             >
      //               <div className="image-section type2 fs-2">
      //                 2
      //               </div>
      //               <div className={`text-section ${activeTab === 'react' ? 'text-danger' : ''}`}>
      //                 <h6 className="fw-bold">React</h6>
      //               </div>
      //             </li>

      //             <li role='button'
      //               className={`d-flex ${activeTab === 'node-js' ? 'active' : ''}`}
      //               onClick={() => handleTabClick('node-js')}
      //             >
      //               <div className="image-section type2 fs-1">
      //                 3
      //               </div>
      //               <div className={`text-section ${activeTab === 'node-js' ? 'text-danger  ' : ''}`}>
      //                 <h6 className="fw-bold">Node & Express js</h6>
      //               </div>
      //             </li>

      //             <li role='button'
      //               className={`d-flex ${activeTab === 'MongoDB' ? 'active' : ''}`}
      //               onClick={() => handleTabClick('MongoDB')}
      //             >
      //               <div className="image-section type2 fs-1">
      //                 4
      //               </div>
      //               <div className={`text-section ${activeTab === 'MongoDB' ? 'text-danger  ' : ''}`}>
      //                 <h6 className="fw-bold">MongoDB</h6>
      //               </div>
      //             </li>

      //             <li role='button'
      //               className={`d-flex ${activeTab === 'full-stack' ? 'active' : ''}`}
      //               onClick={() => handleTabClick('full-stack')}
      //             >
      //               <div className="image-section type2 fs-1 ">
      //                 5
      //               </div>
      //               <div className={`text-section ${activeTab === 'full-stack' ? 'text-danger  ' : ''}`}>
      //                 <h6 className="fw-bold">Full Stack</h6>
      //               </div>
      //             </li>

      //             <li role='button'
      //               className={`d-flex ${activeTab === 'interview-preparation' ? 'active' : ''}`}
      //               onClick={() => handleTabClick('interview-preparation')}
      //             >
      //               <div className="image-section type2 fs-1" >
      //                 6
      //               </div>
      //               <div className={`text-section ${activeTab === 'interview-preparation' ? 'text-danger  ' : ''}`}>
      //                 <h6 className="fw-bold">Interview preparations</h6>
      //               </div>
      //             </li>
      //           </ul>
      //         </div>


      //       </div>
      //     </div>
      //   </div>
      // </section>